import {I18n} from "i18n-js";
import { TranslateOptions } from "i18n-js/src/typing";
import {UserState, useUserState} from "../../store/user-store";
import {Locale, UserSettingsApi} from "../../api/UserSettingsApi";
import { StringKey } from "./keys";

const i18n = new I18n({
    en: {
        greeting: "Hello %{name}!",

    },
    lt: {
        greeting: "Labas %{name}!"
    },
    pl: {
        greeting: "Cześć %{name}!"
    }
});

i18n.missingBehavior = "custom-missing";
i18n.enableFallback = true;
i18n.defaultLocale = "en";

i18n.missingTranslation.register("custom-missing", (_i18n, scope) => {
    const scopeStr = Array.isArray(scope) ? scope.join(".") : scope;
    return `Err: ${scopeStr}`;
});

// load current locale lang bundle
function loadTranslations() {
    const locale = i18n.locale as Locale;
    UserSettingsApi.getLanguageBundle(locale).then((response) => {
        if (response.data) {
            const localeDict = {[locale]: response.data}
            i18n.store(localeDict);
            console.log("Loaded locale bundle", locale)
        }
    });
}

function setupLocale(state?: UserState) {
    console.log("Setting up locale")

    const usedState = state ?? useUserState.getState();
    i18n.locale = usedState.getLanguage()

    loadTranslations()
}

// setup locale on app load, or update it when user changes
if (useUserState.getState().isCurrentUserLoaded) {
    setupLocale()
}

useUserState.subscribe((state) => {
    console.log("User state changed, changin locale", state)
    setupLocale(state)
});

export default function T(key: Readonly<StringKey>, options?: TranslateOptions) {
    return i18n.t(key, options);
}




